import { useEffect, useContext, useRef, useState } from "react";
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Button,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { userOnboardingPublicApi } from "../../services/api.service";
import { userOnboardingContext } from "../../states/context/userOnboardingContext";
import { roleBasedDataMappings, roles } from "../../userOnboardingConstants";
import rightArrow from "../../assets/images/new-arrow-left.svg"
import leftArrow from "../../assets/images/new-arrow-left-colored.svg"

const CustomRadio = styled(Radio)(({ theme }) => ({
  padding: "16px",
  "&.Mui-checked": {
    color: "#6933FF",
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '& .MuiSvgIcon-root': {
    borderRadius: '50%',
    width: 16,
    height: 16,
    border: '1px solid #d1d1d1',
    backgroundColor: 'transparent',
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    backgroundColor: '#6933FF',
    borderColor: '#6933FF',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
    },
  },
  '&.Mui-focusVisible .MuiSvgIcon-root': {
    outline: '2px auto #6933FF',
    outlineOffset: 2,
  },
  '&.Mui-disabled .MuiSvgIcon-root': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)',
  },
}));

const MainContainer = styled('div')(({ theme }) => ({
  display: "flex",
  fontFamily: "Figtree",
  overflow: "hidden",
  overflowY: 'auto',
  '& .PrivateRadioButtonIcon-root-22.PrivateRadioButtonIcon-checked-24 .PrivateRadioButtonIcon-layer-23': {
    transform: 'scale(0)',
  },
}));

const DetailsContainer = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  width: "100%",
  paddingTop: "80px",
  paddingLeft: "108px",
  paddingRight: "63px",
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
}));

const NextButton = styled(Button)(({ theme }) => ({
  width: "120px",
  height: "48px",
  borderRadius: "8px",
  backgroundColor: "#6933FF",
  border: "none",
  outline: "none",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  textTransform: "capitalize",
  "& span": {
    fontFamily: "Figtree",
    marginLeft: "0px",
  },
  "&:hover": {
    backgroundColor: "#5a2fdd",
  },
  "&:disabled": {
    backgroundColor: "#E8E8E8",
    color: "#FFFFFF",
  },
}));

const FormLabel = styled('p')(({ theme }) => ({
  fontFamily: "Figtree",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "normal",
  color: "#171717",
  margin: 0,
  marginBottom: "40px",
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ selected }) => ({
  border: "1px solid #d1d1d1",
  borderRadius: 8,
  width: "100%",
  transition: "border-color 0.3s",
  margin: "0px",
  borderColor: selected ? "#6933FF" : "#d1d1d1",
  "& span": {
    fontFamily: "Figtree",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    color: '#171717',
  },
}));

const GridContainer = styled('div')(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gridGap: "16px",
}));

const GridItem = styled('div')(({ theme }) => ({
  color: "#171717",
  fontFamily: "Figtree",
  fontSize: "16px",
  fontWeight: "400",
}));

const BackButton = styled(Button)(({ theme }) => ({
  height: "48px",
  borderRadius: "8px",
  backgroundColor: "transparent",
  border: "none",
  outline: "none",
  color: "#6933FF",
  fontSize: "16px",
  fontWeight: "600",
  textTransform: "capitalize",
  "& span": {
    fontFamily: "Figtree",
  },
  "&:hover": {
    backgroundColor: "transparent",
  },
}));

const WelcomeHeading = styled('h2')(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "600",
  fontFamily: "Figtree",
  marginTop: 0,
  marginBottom: "24px",
  color: '#171717',
}));

const HeadPara = styled('p')(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "400",
  color: "#747474",
  margin: 0,
}));

const OtherInput = styled(TextField)(({ theme }) => ({
  "& input": {
    paddingLeft: "0px",
    fontFamily: "Figtree",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

function StyledRadio(props) {
  return (
    <CustomRadio
      disableRipple
      color="default"
      {...props}
    />
  );
}

const RoleSelection = () => {
  const { user, setUser } = useContext(userOnboardingContext);
  const navigate = useNavigate();
  const videoRef = useRef(null);
  const [otherValue, setOtherValue] = useState(
    user.role && !roles.includes(user.role) ? user.role : "Other"
  );

  const handleRoleChange = (event) => {
    const selectedRole = event.target.value;
    if (selectedRole !== "other" && otherValue === "") {
      setOtherValue("Other");
    }
    const roleValue = selectedRole === "other" ? otherValue : selectedRole;
    updateUserWithRoleData(selectedRole, roleValue);
  };

  useEffect(() => {
    getUserApiCall();
  }, []);

  const getUserApiCall = async () => {
    // Make API call to get user details
    try {
      const payload = {
        api: "",
        data: {},
      };
      // const result = await userOnboardingPublicApi(payload);
      // if (result.meta === "Success") {
      // setUser({ ...user, role: roles.selected });
      // }
    } catch (error) {
      console.log(error);
    }
  };
  const handleNext = (e) => {
    e.stopPropagation();
    // Handle form submission or navigation
    updateUserApiCall();
  };

  const updateUserApiCall = async () => {
    // Make API call to update user details

    try {
      const payload = {
        api: "",
        data: {
          role: user.role,
        },
      };
      // const result = await userOnboardingPublicApi(payload)
      // if(result.meta === "Success"){
      console.log("success");
      navigate("/onboarding/objective");
      // }else{
      //   console.log("error")
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleBack = () => {
          navigate("/onboarding/start");
  };

  const handleOtherChange = (event) => {
    const value = event.target.value;
    setOtherValue(value);
    updateUserWithRoleData("other", value);
  };

  const handleOtherClick = () => {
    if (otherValue === "Other") setOtherValue("");
    updateUserWithRoleData("other", otherValue);
  };

  const updateUserWithRoleData = (roleKey, roleValue) => {
    const { objectives, challenges, automations } =
      roleBasedDataMappings[roleKey];
    setUser({
      ...user,
      role: roleValue,
      objectives,
      challenges,
      recommendedAutomations: automations,
    });
  };

  return (
    <MainContainer>
      <DetailsContainer>
        <div>
          <WelcomeHeading>Welcome to Kavida.ai</WelcomeHeading>
          <HeadPara>
            Help us <b>build your personalize AI agent</b> by telling us a
            little bit about yourself, the challenges you are facing, and your
            goals.
          </HeadPara>
        </div>
        <div>
          <div>
            <FormLabel> What is your current job role?</FormLabel>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="job-role"
                name="job-role"
                value={
                  user.role
                    ? roles.includes(user.role)
                      ? user.role
                      : "other"
                    : ""
                }
                onChange={handleRoleChange}
              >
                <GridContainer>
                  {roles.map((role) => (
                    <GridItem key={role}>
                      <StyledFormControlLabel
                        value={role}
                        control={<StyledRadio />}
                        label={role}
                        selected={user.role === role}
                      />
                    </GridItem>
                  ))}
                  <GridItem>
                    <StyledFormControlLabel
                      onClick={handleOtherClick}
                      value={"other"}
                      control={<StyledRadio />}
                      selected={user.role && !roles.includes(user.role)}
                      label={
                        <OtherInput
                          value={otherValue}
                          onChange={handleOtherChange}
                          placeholder="Type your answer..."
                          variant="outlined"
                          size="small"
                        />
                      }
                    />
                  </GridItem>
                </GridContainer>
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <ButtonContainer>
          <BackButton onClick={handleBack}>
            <img
              src={leftArrow}
              alt="leftArrow"
              style={{ marginRight: "4px" }}
            />
            Back
          </BackButton>
          <NextButton
            onClick={handleNext}
            disabled={!user.role || otherValue === ""}
          >
            Next
            <img
              src={rightArrow}
              alt="rightArrow"
              style={{ marginLeft: "4px" }}
            />
          </NextButton>
        </ButtonContainer>
      </DetailsContainer>
    </MainContainer>
  );
};

export default RoleSelection;
